import React, { useEffect, useState } from "react";
import { getToken } from "./utils/common";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getUserprofileAction } from "../store/auth/authActions";
import { authActions } from "../store/auth";

const SplashScreen = () => {
  const [typedText, setTypedText] = useState("");
  const textToType = "14 BΛRBER";
  const typingDelay = 100;
  const token = getToken();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    let currentText = "";
    let currentIndex = 0;

    const typingInterval = setInterval(() => {
      if (currentIndex < textToType.length) {
        currentText += textToType[currentIndex];
        setTypedText(currentText);
        currentIndex++;
      } else {
        clearInterval(typingInterval);
      }
    }, typingDelay);

    return () => {
      clearInterval(typingInterval);
    };
  }, []);

  useEffect(() => {
    if (![null, undefined]?.includes(token)) {
      getUserprofileAction(token, navigate)(dispatch);
      dispatch(authActions.setToken({ token }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, token]);

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-[#191a19]">
      <h1 className="text-6xl font-bold text-white font-arial animate-pulse">
        {typedText}
      </h1>
    </div>
  );
};

export default SplashScreen;
